import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import React, { Children, useState, useEffect } from 'react';
import { SignUp, Authenticator, Greetings } from 'aws-amplify-react';
import { theme } from './theme';
import { SUCCESS, HALF_CONTRAST, BACKGROUND_PRIMARY } from '../../theme';
import { StaticImg, Checkbox } from '../../ui';

const noop = () => {};

const Logo = styled(StaticImg)`
  width: 275px;
  margin: 0 auto;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  margin: 0px;
  z-index: 99999999;
  height: 100vh;

  select {
    margin-top: 8px;
    font-size: 16px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 100%;
`;

const PrivacyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${BACKGROUND_PRIMARY};
  align-items: center;
  flex: 1;
`;

const InnerPrivacyContainer = styled.div`
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  margin-top: 32px;
`;
const Button = styled.div`
  color: white;
  background-color: ${SUCCESS};
  padding: 12px;
  border-radius: 4px;
  opacity: ${({ inactive }) => (inactive ? 0.5 : 1)};
  pointer-events: ${({ inactive }) => (inactive ? 'none' : 'auto')};
`;
const Title = styled.h2`
  color: ${HALF_CONTRAST};
  font-size: 24px;
  margin: 0 0 16px 0;
`;

const Noop = () => <div />;
const mapState = ({ termsAccepted, canSignUp, isPublic }) => ({
  termsAccepted,
  canSignUp,
  isPublic,
});

export const Auth = ({ children, onChange = noop }) => {
  const dispatch = useDispatch();
  const { canSignUp, termsAccepted, isPublic } = useSelector(mapState);
  const [authed, setAuthed] = useState('');
  if (authed === 'signedIn' && !children) return null;

  if (isPublic) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => dispatch({ type: 'CHECK_FOR_ACCESS' }), [dispatch]);

    return (
      <Container>
        {children ? Children.only(children) : <Noop />}
      </Container>
    );
  }

  const hiddenComponents = [Greetings];
  if (!canSignUp) hiddenComponents.push(SignUp);

  return (
    <Container>
      {authed !== 'signedIn' ? (
        <Header>
          <Logo src="/dynamo-primary-logo.png" alt="Dynamo Metrics" />
        </Header>
      ) : null}
      {canSignUp && !termsAccepted ? (
        <PrivacyPolicy onClick={() => dispatch({ type: 'ACCEPT_TERMS' })} />
      ) : (
        <Authenticator
          authState="signIn"
          onStateChange={(authState) => {
            onChange(authState);
            setAuthed(authState);
            dispatch({ type: 'CHECK_FOR_ACCESS' });
          }}
          theme={theme}
          hide={hiddenComponents}
        >
          {children ? Children.only(children) : <Noop />}
        </Authenticator>
      )}
    </Container>
  );
};

const Accept = styled.div`
  display: flex;
  flex-direction: row;
`;
const Paragraph = styled.p`
  text-align: left;
  padding-left: 8px;
`;

const PrivacyPolicy = ({ onClick }) => {
  const [agreed, setAgreed] = useState(false);
  return (
    <PrivacyContainer>
      <InnerPrivacyContainer>
        <Title>Terms of Service</Title>
        <Accept>
          <Checkbox checked={agreed} onClick={() => setAgreed(!agreed)} />
          <Paragraph>
            I acknowledge that I have read and agree to the terms of the&nbsp;
            <a
              href="https://www.dynamometrics.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Dynamo Metrics End User License Agreement
            </a>
            .
          </Paragraph>
        </Accept>
        <br />
        <Button inactive={!agreed} onClick={onClick}>
          Accept
        </Button>
      </InnerPrivacyContainer>
    </PrivacyContainer>
  );
};
